import {useVariationParams} from '@salesforce/retail-react-app/app/hooks/use-variation-params'
import {isVariantPurchasable} from './use-variation-attributes'

const hasValue = (value) => value !== undefined && value !== null && value !== ''

export const useVariant = (
    product = {},
    isProductPartOfSet = false,
    isProductPartOfBundle = false
) => {
    const {variants = [], variationAttributes = []} = product
    const variationParams = useVariationParams(product, isProductPartOfSet, isProductPartOfBundle)

    const filteredVariants = variants.filter(({variationValues}) =>
        Object.keys(variationParams).every((key) => variationValues[key] === variationParams[key])
    )

    if (filteredVariants.length === 1) {
        return filteredVariants[0]
    }

    const choicePending = variationAttributes
        .filter(({id}) => !(id in variationParams))
        .some(({id}) => {
            const values = filteredVariants.map(({variationValues}) => variationValues[id])
            return new Set(values.filter(hasValue)).size > 1
        })

    if (choicePending) {
        return undefined
    }

    const orderableVariants = filteredVariants.filter(isVariantPurchasable)

    return orderableVariants.length === 1 ? orderableVariants[0] : undefined
}
